import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StarIcon from '@mui/icons-material/Star';

const reasons = [
  'Certified & trained installation team',
  'Genuine branded products with warranty',
  'Free site survey & consultation',
  'Competitive & transparent pricing',
  'Quick 48-hour installation turnaround',
  'Post-installation training included',
  'Local support team in Pune',
  'Trusted by 500+ happy clients',
];

export default function WhyUs() {
  return (
    <Box
      id="about"
      sx={{
        py: 12,
        background: 'linear-gradient(135deg, #061525 0%, #0a2540 100%)',
        position: 'relative', overflow: 'hidden',
      }}
    >
      {/* Decorative circle */}
      <Box sx={{
        position: 'absolute', width: 500, height: 500, borderRadius: '50%',
        border: '1px solid rgba(30,144,212,0.08)',
        right: -200, top: '50%', transform: 'translateY(-50%)',
        zIndex: 0,
      }} />
      <Box sx={{
        position: 'absolute', width: 300, height: 300, borderRadius: '50%',
        border: '1px solid rgba(30,144,212,0.05)',
        right: -100, top: '50%', transform: 'translateY(-50%)',
        zIndex: 0,
      }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontSize: '0.8rem', letterSpacing: '3px', color: '#1e90d4', textTransform: 'uppercase', mb: 2, fontWeight: 600 }}>
              Why Choose Us
            </Typography>
            <Typography variant="h2" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, color: '#e8f0fe', mb: 3 }}>
              Pune's Most{' '}
              <Box component="span" sx={{ color: '#1e90d4' }}>Trusted</Box>
              <br />CCTV Partner
            </Typography>
            <Typography sx={{ color: '#8fb3d9', lineHeight: 1.8, mb: 5, maxWidth: 480 }}>
              With over 15 years of experience in the security industry, CCTV Partner has established itself
              as the go-to surveillance solution provider across Pune and Maharashtra. We combine
              cutting-edge technology with personalized service.
            </Typography>

            <Grid container spacing={2}>
              {reasons.map((reason, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <CheckCircleIcon sx={{ color: '#1e90d4', fontSize: 20, mt: 0.2, flexShrink: 0 }} />
                    <Typography sx={{ color: '#8fb3d9', fontSize: '0.9rem' }}>
                      {reason}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative' }}>
              {/* Big rating card */}
              <Box sx={{
                background: 'linear-gradient(135deg, rgba(13,40,71,0.9), rgba(8,24,45,0.9))',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(30,144,212,0.2)',
                borderRadius: '16px',
                p: 5, textAlign: 'center',
                boxShadow: '0 24px 60px rgba(0,0,0,0.4)',
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5, mb: 2 }}>
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} sx={{ color: '#f0c040', fontSize: 28 }} />
                  ))}
                </Box>
                <Typography sx={{
                  fontSize: '5rem', fontWeight: 900, lineHeight: 1,
                  fontFamily: '"Playfair Display", serif',
                  background: 'linear-gradient(135deg, #1e90d4, #64b5e8)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                  mb: 1,
                }}>
                  4.9
                </Typography>
                <Typography sx={{ color: '#e8f0fe', fontWeight: 600, mb: 0.5 }}>
                  Average Customer Rating
                </Typography>
                <Typography sx={{ color: '#8fb3d9', fontSize: '0.85rem' }}>
                  Based on 350+ Google Reviews
                </Typography>

                <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid rgba(30,144,212,0.15)', display: 'flex', justifyContent: 'space-around' }}>
                  {[
                    { num: '500+', label: 'Projects' },
                    { num: '15+', label: 'Yrs Exp' },
                    { num: '50+', label: 'Brands' },
                  ].map((s, i) => (
                    <Box key={i} sx={{ textAlign: 'center' }}>
                      <Typography sx={{ fontSize: '1.8rem', fontWeight: 700, color: '#1e90d4', fontFamily: '"Playfair Display", serif', lineHeight: 1 }}>
                        {s.num}
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem', color: '#8fb3d9', textTransform: 'uppercase', letterSpacing: 1 }}>
                        {s.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
